export const checkoutUrl = 'https://rhythmic-gym-pro.impultienda.ar/checkout'

export const purchaseAnchor = '#offerta'

export const productImage =
  'https://cdn.magicpatterns.com/uploads/fhBTYMt9wicJX5DTSiny4T/ChatGPT-Image-29-jul-2026_-06_36_12-p.m..webp'

export const productName = 'RHYTHMIC GYM PRO™'
